/**
 * Estonian addresses reach us in two orders, because the ADS gazetteer
 * (inaadress.maaamet.ee) returns both and older rows were saved from the wrong
 * field:
 *
 *   taisaadress / pikkaadress → "Harju maakond, Tallinn, Põhja-Tallinna linnaosa, Kopli tn 35b"
 *   ipikkaadress             → "Kopli tn 35b, Põhja-Tallinna linnaosa, Tallinn, Harju maakond"
 *
 * Displays use the street-first order (street, district, city, county), so a
 * county-first string is reversed on the way to the screen. Everything else is
 * returned untouched.
 */

// The county-first ADS forms always start with "<name> maakond"; that is the
// only marker needed to tell the two orders apart.
// ponytail: doesn't catch the legacy short county form ("Harjumaa, Tallinn, …").
// Add that suffix test if such rows ever show up — the "-maa" ending is
// ambiguous enough (street names end in it too) that it needs real examples.
const COUNTY_FIRST = /^\S+\s+maakond$/i;

// taisaadress appends an apartment as its own trailing comma part ("Lai tn 50, 5"
// or "Kerese tn 3, korter 12") while ipikkaadress folds it into the street part
// ("Lai tn 50-5"). Fold before reversing so the apartment can't lead the line.
const APARTMENT = /^(korter\s+)?\d+\w*$/i;

export function formatBuildingAddress(address: string | null | undefined): string {
  if (!address) return "";
  const parts = address
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length < 2 || !COUNTY_FIRST.test(parts[0])) return address;
  if (parts.length > 2 && APARTMENT.test(parts[parts.length - 1])) {
    const apartment = (parts.pop() ?? "").replace(/^korter\s+/i, "");
    parts[parts.length - 1] += `-${apartment}`;
  }
  return parts.reverse().join(", ");
}
